import styled, { css } from 'styled-components';

import { justifyContentFlexEnd } from '../../styles/commonStyles';

// Shared by ChartScaleControls and ChartDetailControls so the two overlay
// rows cannot drift apart visually.
export const ControlRow = styled.div`
  height: 24px;
  ${justifyContentFlexEnd};
  align-items: center;
`;

// No pointer-events:none on the disabled state — the native disabled
// attribute already blocks onClick, and pointer-events:none makes
// user-event v13 throw instead of no-op when a test clicks it.
export const ControlButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`;

export const ControlIcon = styled.img`
  width: fit-content;
  border-radius: 50%;
`;

export const ControlLabel = styled.span`
  font-size: 10px;
  margin-left: 8px;
  margin-right: 8px;
  white-space: nowrap;
`;
